import { gql } from '@apollo/client'

export const CREATE_USER_PROFILE_MUTATION = gql`
    mutation CreateUserProfile($input: CreateUserProfileInput!) {
        createUserProfile(input: $input) {
            id
            email
            firstName
            lastName
            phone
            dateOfBirth
            countryId
            country {
                id
                name
                abbreviation
                _version
                _deleted
                _lastChangedAt
                createdOn
                updatedOn
                owner
            }
        }
    }
`

export const UPDATE_USER_PROFILE_MUTATION = gql`
    mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
        updateUserProfile(input: $input) {
            id
            firstName
        }
    }
`

export const IMPACT_USER_PRODUCT_INTEREST_MUTATION = gql`
    mutation UpdateUserProductInterest($input: ImpactUserInterestsInput!) {
        impactUserInterests(input: $input) {
            deleted
            created
        }
    }
`
